//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'paletizado_Id';

export default function PaletizadosTable(props) {
    const [pageSize, setPageSize] = React.useState(25);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            //field: 'error',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'proveedor',
            headerName: intl.formatMessage({ id: 'Proveedor' }),
            editable: false,
            width: 180,
        },
        {
            field: 'contenedor',
            headerName: intl.formatMessage({ id: 'Contenedor' }),
            editable: false,
            width: 120,
        },
        {
            field: 'etiquetaCore',
            headerName: intl.formatMessage({ id: 'EtiquetaCore' }),
            editable: false,
            flex: 180,
        },
        {
            field: 'calibre',
            headerName: intl.formatMessage({ id: 'Calibre' }),
            editable: false,
            flex: 120,
        },
        {
            field: 'codigoTMU',
            headerName: intl.formatMessage({ id: 'CodigoTMU' }),
            editable: false,
            width: 120,
        },
    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        paletizado_Id: false,
    });
    return (
        
        <div>
            <Box sx={{
                height: 500, width: '100%',
            }}>

                <StripedDataGrid
                    rows={props.data}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[25, 50]}
                    pagination
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },
                        },
                    }}
                    disableMultipleRowSelection={true}
                    onRowSelectionModelChange={(id) => props.table_onselect(id)}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
